/**
 * This is lazy loading config that initiate when open the webpage
 * DON'T import any module here. Ohterwise, the module will be loaded and lost the lazy loading.
 * */

import { withAsync } from '../../components/lazyLoading/async-component';
import { withPNHoc } from '../../hoc/policyNumber/withPNHoc';
import { t } from '../../locales';
import modalSaga from "../../modules/emma-customer-profile/sagas/modalSaga";

const MODULE_FOLDER_NAME = 'emma-customer-profile'; // Folder name of the module for lazy import
const MODULE_NAME = 'hk-emma-web-module-customer-profile'; // Module name from package.json
const ROOT_PATHS = ['customerprofile']; // Root path of the routes

export default {
  preloadModules: [
    {
      moduleFolderNames: [MODULE_FOLDER_NAME],
      preloadSagas: [modalSaga], // HKEMMA-130974 => FRAME_APP_MOUNTED action not run if not enable this module
    },
  ],
  modules: [
    {
      moduleName: MODULE_NAME,
      routes: {
        rootPaths: ROOT_PATHS,
        subPaths: {
          '': {
            exact: true,
            enableMobileRoute: true,
            sidebarItem: {
              label: t('CUSTOMER_PROFILE'),
              iconDefault: `/assets/images/customer-profile/customer-profile.svg`,
              iconSelected: `/assets/images/customer-profile/customer-profile-selected.svg`,
              priority: 300,
              includedRoutes: ['/home/life/portal/emma/generic-support'],
            },
            container: withAsync(MODULE_FOLDER_NAME, ''),
          },
          '/renewalupdate/:policy_number': {
            exact: true,
            enableMobileRoute: true,
            container: withPNHoc(
              withAsync(MODULE_FOLDER_NAME, '/renewalupdate/:policy_number'),
            ),
          },
          '/renewalupdate/changeemail/edit': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changeemail/edit',
            ),
          },
          '/renewalupdate/changeemail/updatepolicy': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changeemail/updatepolicy',
            ),
          },
          '/renewalupdate/changeemail/gogreen': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changeemail/gogreen',
            ),
          },
          '/renewalupdate/changeemail/review': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changeemail/review',
            ),
          },
          '/renewalupdate/changeemail/verify': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changeemail/verify',
            ),
          },
          '/renewalupdate/changeemail/submiterror': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changeemail/submiterror',
            ),
          },
          '/renewalupdate/changeemail/confirm': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changeemail/confirm',
            ),
          },
          '/renewalupdate/changemobile/edit': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changemobile/edit',
            ),
          },
          '/renewalupdate/changemobile/updatepolicy': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changemobile/updatepolicy',
            ),
          },
          '/renewalupdate/changemobile/gogreen': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changemobile/gogreen',
            ),
          },
          '/renewalupdate/changemobile/review': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changemobile/review',
            ),
          },
          '/renewalupdate/changemobile/verify': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changemobile/verify',
            ),
          },
          '/renewalupdate/changemobile/submiterror': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changemobile/submiterror',
            ),
          },
          '/renewalupdate/changemobile/confirm': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/changemobile/confirm',
            ),
          },
          '/renewalupdate/errorcode/:feature_id/:error_code': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/renewalupdate/errorcode/:feature_id/:error_code',
            ),
          },
          '/changecontact': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changecontact'),
          },
          '/changeaddress': {
            exact: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeaddress'),
          },
          '/changeemail/edit': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeemail/edit'),
          },
          '/changeemail/updatepolicy': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/changeemail/updatepolicy',
            ),
          },
          '/changeemail/gogreen': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeemail/gogreen'),
          },
          '/changeemail/review': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeemail/review'),
          },
          '/changecontact/downloadform': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/changecontact/downloadform',
            ),
          },
          '/contactdetails/:policy_number': {
            exact: true,
            enableMobileRoute: true,
            container: withPNHoc(
              withAsync(MODULE_FOLDER_NAME, '/contactdetails/:policy_number'),
            ),
          },
          '/changeemail/verify': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeemail/verify'),
          },
          '/changeemail/submiterror': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/changeemail/submiterror',
            ),
          },
          '/changeemail/confirm': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeemail/confirm'),
          },
          '/changemobile/edit': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changemobile/edit'),
          },
          '/changemobile/updatepolicy': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/changemobile/updatepolicy',
            ),
          },
          '/changemobile/gogreen': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changemobile/gogreen'),
          },
          '/changemobile/review': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changemobile/review'),
          },
          '/changemobile/verify': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changemobile/verify'),
          },
          '/changemobile/submiterror': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/changemobile/submiterror',
            ),
          },
          '/changemobile/confirm': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changemobile/confirm'),
          },
          '/reset': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/reset'),
          },
          '/reset/usename': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/reset/usename'),
          },
          '/reset/usename/confirm': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/reset/usename/confirm'),
          },
          '/reset/password': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/reset/password'),
          },
          '/reset/password/confirm': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/reset/password/confirm'),
          },
          '/reset/verify': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/reset/verify'),
          },
          '/insuredaccess': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/insuredaccess'),
          },
          '/insuredaccess/deactivate': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/insuredaccess/deactivate',
            ),
          },
          '/errorcode/:feature_id/:error_code': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/errorcode/:feature_id/:error_code',
            ),
          },
          '/changeaddress/updatepolicy': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/changeaddress/updatepolicy',
            ),
          },
          '/changeaddress/review': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeaddress/review'),
          },
          '/changeaddress/confirm': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeaddress/confirm'),
          },
          '/changeaddress/edit': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeaddress/edit'),
          },
          '/changeaddress/chooselocation/:type': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(
              MODULE_FOLDER_NAME,
              '/changeaddress/chooselocation/:type',
            ),
          },
          '/changeaddress/abbreviation': {
            exact: true,
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/changeaddress/abbreviation'),
          },
        },
      },
    },
  ],
};
